import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/serverError";
import { RootStore } from "./rootStore";

export default class CommonStore {
    rootStore?: RootStore;
    error: ServerError | null = null;
    fixed:boolean = false;
    activePageName:string ="home";
    token: string | null = localStorage.getItem('jwt');
    dropdownMenuStyle: string = 'none';
    appLoaded = false;
    
    constructor(rootStore?: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);

        reaction(
            () => this.token,
            token => {
                if (token) {
                    localStorage.setItem('jwt', token)
                } else {
                    localStorage.removeItem('jwt')
                }
            }
        )
    }

    setServerError(error: ServerError) {
        this.error = error;
    }

    setToken = (token: string | null) => {
        this.token = token;
    }

    setAppLoaded = (value:boolean) => {
        this.appLoaded = value;
    }

    setActivePageName = (value:string) =>{
        this.activePageName = value;
    }
}